import React from 'react'
import Tooltip from 'uiKit/Tooltip'
import { CheckboxContainer, CheckboxInput, Checkmark } from './Checkbox.styles'

interface Props {
  color?: string
  checked: boolean
  onChange: (a: boolean) => void
  label?: string
  disabled?: boolean
  /** Shown on hover only while disabled. */
  tooltip?: string
  tooltipId?: string
  /** react-tooltip `place`; defaults to the library's top placement. */
  tooltipPlace?: string
}

const Checkbox: React.FC<Props> = ({
  color,
  checked,
  onChange,
  label,
  disabled = false,
  tooltip,
  tooltipId,
  tooltipPlace,
}) => {
  const style: { [key: string]: string } = {
    '--theme-color': color || 'var(--color-button-secondary)',
  }
  const showTooltip = Boolean(disabled && tooltip && tooltipId)

  const handleChange = () => {
    if (disabled) return
    onChange && onChange(!checked)
  }

  return (
    <>
      <CheckboxContainer
        onClick={handleChange}
        $disabled={disabled}
        aria-disabled={disabled}
        {...(showTooltip ? { 'data-for': tooltipId, 'data-tip': true } : {})}
      >
        <CheckboxInput checked={checked} onChange={handleChange} disabled={disabled} />
        <Checkmark style={style} />
      </CheckboxContainer>
      {showTooltip && <Tooltip id={tooltipId} place={tooltipPlace}>{tooltip}</Tooltip>}
    </>
  )
}

export default Checkbox
